import { FC, useState } from "react";
import { Trash2 } from "lucide-react";
import { useAuthenticated } from "../../shared/hooks/useAuthenticated";
import { AppButton, FigmaTypography } from "@libs/zapi-ui/custom";
import $api from "../../shared/api/axios";

export const DashboardPage: FC = () => {
  const { user } = useAuthenticated();
  const [isClearingCache, setIsClearingCache] = useState(false);

  const handleClearCache = async () => {
    if (!window.confirm("Are you sure you want to clear the snippets cache?")) {
      return;
    }
    setIsClearingCache(true);
    try {
      const response = await $api.delete<{ message: string; deletedCount: number }>("/admin/cache/snippets");
      alert(`${response.data.message} (${response.data.deletedCount} entries deleted)`);
    } catch (error) {
      console.error("Failed to clear cache:", error);
      alert("Failed to clear snippets cache");
    } finally {
      setIsClearingCache(false);
    }
  };

  return (
    <div className="container mx-auto py-8">
      <div className="flex justify-between items-center mb-6 pr-6">
        <FigmaTypography component="h1" variant="heading-1">Admin Dashboard</FigmaTypography>
        <AppButton
          appearance="outlined"
          color="zinc950"
          onClick={handleClearCache}
          disabled={isClearingCache}
          className="flex items-center gap-2 px-4 py-2 h-fit"
        >
          <Trash2 size={16} className={isClearingCache ? "animate-pulse" : ""} />
          {isClearingCache ? "Clearing..." : "Clear Snippets Cache"}
        </AppButton>
      </div>

      <div className="rounded-lg border bg-card p-6 shadow-sm">
        <FigmaTypography component="h2" variant="memo-heading-2" className="mb-4">Your Profile</FigmaTypography>
        <div className="space-y-2">
          <p>
            <span className="font-medium">Name:</span> {user?.firstName} {user?.lastName}
          </p>
          <p>
            <span className="font-medium">Email:</span> {user?.email}
          </p>
          <p>
            <span className="font-medium">Role:</span> {user?.role}
          </p>
          <p>
            <span className="font-medium">Organization ID:</span> {user?.organizationId}
          </p>
        </div>
      </div>
    </div>
  );
};
